import { observer } from "mobx-react-lite";
import React, { useState, lazy, useEffect } from "react";
import { SRAddCrumbs } from "./sr-components";
import { FeatureHeader } from "../../components-new";
import { SideOverlay } from "../../components";
import {
    FilterOverLay,
    SearchVoterList,
    VoterListWithRadioButton,
} from "../../features";
import { useStore } from "../../helpers";
import Tab from "@mui/material/Tab";
import AddServiceRequestSubject from "./add-service-request-subject";
import { StyledTabs } from "./sr-styles";
import { TabPanel, TabContext } from "@mui/lab";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const AddServiceRequest = lazy(
    () => import("../service-requests/add-service-request")
);

const TAB_KEYS = ["beneficiary_details", "request_related_info"];

const AddServiceRequestHome = observer((props: any) => {
    const { voterListStore, serviceRequestsStore } = useStore();
    const location = useLocation();
    const isEditMode = location.pathname.includes("editrequest");

    const close_voterList = () => {
        voterListStore.setShowVoterlist(false);
    };
    const { t } = useTranslation(["service_request_home", "beneficiary"]);
    const { showVoterlist, FilterStatus, currentTabValue, setCurrentTabValue } =
        voterListStore;
    // const [c] = useState(TAB_KEYS[0]);

    const navigateNextTab = () => {
        setCurrentTabValue(TABS[1]);
    };
    const TABS = TAB_KEYS.map((key) => t(key));
    useEffect(() => {
        setCurrentTabValue(TAB_KEYS[0]);
    }, []);

    /*
     * Start a clean form for "new request" so previous voter / subject /
     * request values do not leak into the next create flow.
     * Edit mode keeps existing activeServiceRequest data.
     */
    useEffect(() => {
        if (isEditMode) return;

        voterListStore.update_active_voter({});
        serviceRequestsStore.setFamilyMembers([]);
        serviceRequestsStore.setActiveServiceRequest(null);
        serviceRequestsStore.setSubjectId(-1);
        localStorage.removeItem("sr-subject");
        localStorage.removeItem("sr-subject-saved");
        setCurrentTabValue("beneficiary_details");
    }, [isEditMode, location.pathname]);

    const close_Filter_modal = () => {
        voterListStore.setFilterStatus(false);
        voterListStore.setShowVoterlist(true);
        voterListStore.setFilterVal(null);
        voterListStore.setSelectedBooths([]);
    };

    return (
        <>
            <div>
                <SRAddCrumbs />
                <div className={"px-4 pb-4"}>
                    <FeatureHeader title={t("add_new_sr")} />
                    <TabContext value={currentTabValue}>
                        <StyledTabs
                            // @ts-ignore
                            indicatorColor={"primary.main"}
                            variant={"fullWidth"}
                            onChange={(e, value) => setCurrentTabValue(value)}
                        >
                            {TAB_KEYS.map((key) => (
                                <Tab
                                    key={key}
                                    label={t(key)}
                                    value={key}
                                    sx={{
                                        fontSize: {
                                            xs: "14px !important",
                                            sm: "18px !important",
                                        },
                                    }}
                                />
                            ))}
                        </StyledTabs>

                        <TabPanel
                            sx={{ padding: "12px" }}
                            value={"beneficiary_details"}
                            keepMounted
                        >
                            <AddServiceRequestSubject
                                navigateNext={() =>
                                    setCurrentTabValue("request_related_info")
                                }
                            />
                        </TabPanel>
                        <TabPanel
                            sx={{ padding: "0px" }}
                            value={"request_related_info"}
                            keepMounted
                        >
                            <AddServiceRequest />
                        </TabPanel>
                    </TabContext>

                    <SideOverlay
                        onClose={close_voterList}
                        show={showVoterlist}
                        title={t("search_voters", { ns: "beneficiary" })}
                        size={"5xl"}
                    >
                        <SearchVoterList />
                        <VoterListWithRadioButton
                            onVoterSelection={close_voterList}
                        />
                    </SideOverlay>
                    <SideOverlay
                        children={<FilterOverLay />}
                        onClose={close_Filter_modal}
                        show={FilterStatus}
                        title={t("filter_votersearch", { ns: "beneficiary" })}
                    />
                </div>
            </div>
        </>
    );
});

export default AddServiceRequestHome;
